// Module-level singleton worker: survives component unmount/remount so the
// supercluster index doesn't have to be rebuilt on every navigation.

let _scWorker: Worker | null = null;
let _loadedPinKey = '';

export const getScWorker = (): Worker | null => {
  if (typeof window === 'undefined') return null;
  if (!_scWorker) {
    _scWorker = new Worker(new URL('./supercluster.worker.js', import.meta.url));
    _loadedPinKey = '';
  }
  return _scWorker;
};

export const getLoadedPinKey = (): string => _loadedPinKey;
export const setLoadedPinKey = (key: string): void => { _loadedPinKey = key; };
